import {TripCollection} from "./Trip";
import corvin from "../../assets/child/corvin.jpg"

const multidayChildTrips: TripCollection = {
    imageSrc: corvin,
    trips: [
        {
            name: "Alba Iulia - Hunedoara",
            route: "Alba Iulia - Hunedoara - Sarmisegetusa",
            days: [
                // ziua 1
                [
                    {
                        locationName: "Casa Memorială Lucian Blaga, Lancrăm",
                        details: "tur ghidat"
                    },
                    {
                        locationName: "cazare Hotel Cetate, Alba Iulia",
                        details: "hotel de 3 stele"
                    },
                    {
                        locationName: "masa la restaurant",
                        details: "în cetate"
                    },
                    {
                        locationName: "Muzeul Național al Unirii",
                    },
                    {
                        locationName: "Muzeul Principia",
                    },
                    {
                        locationName: "timp liber prin Cetatea ALba Carolina",
                        details: "cu grupuri însoțite de profesori, în funcție de preferințe"
                    },
                    {
                        locationName: "cina",
                        details: "la hotel"
                    }
                ],
                // ziua 2
                [
                    {
                        locationName: "mic dejun și check-out",
                        details: "lo hotel"
                    },
                    {
                        locationName: "Castelul Corvinilor, Hunedoara",
                        details: "plimbare liberă prin castel, în grupuri însoțite de profesori"
                    },
                    {
                        locationName: "Orașul Antic și Muzeul Sarmisegetusa",
                        details: "tururi ghidate de arheologi"
                    },
                    {
                        locationName: "cina în Sebeș",
                        details: "în Sebeș"
                    }
                ]
            ]
        },
    ]
}

export default multidayChildTrips;